import React from "react";

const RentalGuidePage = () => {
  const sectionData = [
    {
      title: "🏡 Select Your Locality",
      description:
        "Choose a location near your workplace and map out your travel times via the commute routes. Ensure the locality meets your needs, offers good schools, and has quick access to healthcare.",
      items: [
        {
          text: "Does the locality fulfill all your needs?",
          image: "/sitevisits.png",
        },
        {
          text: "Is it offering good schools for your children?",
          image: "/expert.png",
        },
        {
          text: "Does it give quick access to healthcare?",
          image: "/shortlist.png",
        },
      ],
    },
    {
      title: "🚀 Launch Your Property Search",
      description: "Three critical factors to consider when looking for properties:",
      items: [
        {
          text: "Property Type: Choose furnished, semi, or fully furnished flats.",
          image: "/deals.png",
        },
        {
          text: "Budget: Factor in rent, deposit, groceries, utilities, and transport.",
          image: "/pricenegotiation.png",
        },
        {
          text: "Verified Listings: Use Homebazaar.com for no-brokerage listings.",
          image: "/searchProperties.png",
        },
      ],
    },
    {
      title: "📋 Shortlist Homes",
      description:
        "Visit the sites and ask the landlords questions. Keep these in mind:",
      items: [
        {
          text: "Inspect Flats: Check plumbing, electric switches, and appliances.",
          image: "/sitevisits.png",
        },
        {
          text: "Know Tenant Rules: Ensure the society's rules match your lifestyle.",
          image: "/shortlist.png",
        },
      ],
    },
    {
      title: "⚠️ Additional Things To Keep In Mind",
      description:
        "Focus on safety, nighttime visibility, and ensure everything works.",
      items: [
        {
          text: "Scan flats and conduct a pest check before moving in.",
          image: "/expert.png",
        },
        {
          text: "Take videos of appliances to verify their working state.",
          image: "/searchProperties.png",
        },
      ],
    },
    {
      title: "💬 Estimate Hidden Costs & Negotiate",
      description:
        "Understand and negotiate costs like maintenance, electricity, and parking:",
      items: [
        {
          text: "Discuss hidden costs and define responsibilities in the agreement.",
          image: "/pricenegotiation.png",
        },
        {
          text: "Research average rent values before negotiating.",
          image: "/shortlist.png",
        },
        {
          text: "Highlight your long-term stay to reduce asking prices.",
          image: "/deals.png",
        },
      ],
    },
    {
      title: "📜 Draft A Rental Agreement",
      description:
        "Include all necessary details and register the agreement before moving in:",
      items: [
        {
          text: "Begin and end date of tenancy.",
          image: "/deals.png",
        },
        {
          text: "Monthly rent and security deposit.",
          image: "/pricenegotiation.png",
        },
        {
          text: "Responsibility for maintenance and repair charges.",
          image: "/expert.png",
        },
        {
          text: "Terms, notice period, and renewal dates.",
          image: "/homeLoans.png",
        },
      ],
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          Looking For Your Next Rental?
        </h1>
        <p className="text-gray-600 mt-2">
          We're here to help you find your perfect home as quickly as possible!
        </p>
      </header>

      {/* Sections */}
      {sectionData.map((section, index) => (
        <section key={index} className="my-8">
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-gray-600 mb-4">{section.description}</p>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.items.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center bg-gray-50 shadow-md rounded-lg p-4"
                >
                  <img
                    src={item.image}
                    alt={item.text}
                    className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
                  />
                  <p className="text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default RentalGuidePage;
